import { User } from '@types'
import { client } from './client'

const signupService = async (user: User, parentId: string, cocap: string) => {
  const { data } = await client.post(
    '/person',
    {
      ...user,
      parent: parentId
    },
    {
      headers: {
        cocap
      }
    }
  )
  return data
}

export { signupService }
